import i18next from "i18next";

import RecommendationFlightItemComponent from "../RecommendationFlightItemComponent";

import { VtripNotice, Wrapper } from "./style";

const RecommendationFlightsComponent = ({ recommendation }) => {
  const {
    routes,
    brandRecId,
    rec_id: recId,
    validating_supplier: validatingSupplier,
    has_branded_tariffs: hasBrandedTariffs,
    brand_name,
    is_vtrip: isVtrip,
    is_dtrip: isDtrip,
  } = recommendation;
  const { t } = i18next;

  return (
    <Wrapper>
      {/* Составной перелёт (is_vtrip / is_dtrip из connectors): отдельные билеты, возврат/обмен независимы */}
      {(isVtrip === true || isDtrip === true) && <VtripNotice>{t("vtrip_notice")}</VtripNotice>}
      {routes.map((route, index) => (
        <RecommendationFlightItemComponent
          key={index}
          recId={recId}
          route={route}
          validatingSupplier={validatingSupplier}
          hasBrandedTariffs={hasBrandedTariffs}
          brandRecId={brandRecId}
          brandName={brand_name}
        />
      ))}
    </Wrapper>
  );
};

export default RecommendationFlightsComponent;
